import React, { useRef, useEffect, useState } from 'react';
import { message } from 'antd';
import { apiHolder, apis } from 'api';
import { currentMailSize as getCurrentMailSize } from '@web-common/state/getter';
import './index.scss';
import { useActions, useAppSelector } from '@web-common/state/createStore';
import { AttachmentActions, MailActions } from '@web-common/state/reducer';
import { preUploadAttachment } from '../../util';
import { useGetProductAuth } from '@web-common/hooks/useGetProductAuth';
import useCreateCallbackForEvent from '@web-common/hooks/useCreateCallbackForEvent';
const diskApi = apiHolder.api.requireLogicalApi(apis.netStorageImpl);
const HOCUploadAttachmentWithFiles = (Component) => React.forwardRef((props, ref) => {
    const currentMail = useAppSelector(state => state.mailReducer.currentMail);
    const currentMailId = useAppSelector(state => state.mailReducer.currentMail.cid);
    const attachments = useAppSelector(state => state.attachmentReducer.attachments);
    const currentMailSize = getCurrentMailSize(currentMail, attachments);
    const refCurrentMail = useRef(currentMail);
    const { doAddAttachment } = useActions(AttachmentActions);
    const { doModifySubject } = useActions(MailActions);
    const currentMailIdRef = useRef(currentMailId);
    const currentMailSizeRef = useRef(currentMailSize);
    const [cloudAttInfo, setCloudAttInfo] = useState();
    const { productVersionInfo: { productVersionId }, } = useGetProductAuth();
    useEffect(() => {
        currentMailIdRef.current = currentMailId;
    }, [currentMailId]);
    useEffect(() => {
        refCurrentMail.current = currentMail;
    }, [currentMail]);
    useEffect(() => {
        diskApi.doGetNSFolderInfo({ type: 'cloudAtt' }).then(res => {
            setCloudAttInfo(res);
        });
    }, []);
    useEffect(() => {
        currentMailSizeRef.current = currentMailSize;
    }, [currentMailSize]);
    const modifyTitle = (fileName) => {
        var _a;
        if (!((_a = refCurrentMail.current.entry) === null || _a === void 0 ? void 0 : _a.title)) {
            const name = fileName.split('.');
            name.length > 1 && name.pop();
            doModifySubject(name.join('.'));
        }
    };
    const uploadAttachmentAction = useCreateCallbackForEvent((fileList, usingCloud) => {
        var _a;
        if (!currentMailIdRef.current)
            return;
        let preTrtAtts = preUploadAttachment({
            fileList,
            currentMailId: currentMailIdRef.current,
            currentMailSize: currentMailSizeRef.current,
            _account: (currentMail === null || currentMail === void 0 ? void 0 : currentMail.initSenderStr) || '',
            cloudAttInfo: cloudAttInfo,
            flag: { usingCloud },
        });
        if (!preTrtAtts || preTrtAtts.length !== fileList.length) {
            message.error('附件上传失败，请检查附件是否符合要求');
            return;
        }
        preTrtAtts = preTrtAtts.filter(file => (file === null || file === void 0 ? void 0 : file.fileSize) !== 0);
        if (!preTrtAtts.length) {
            message.error('附件大小异常');
            return;
        }
        modifyTitle((_a = preTrtAtts[0]) === null || _a === void 0 ? void 0 : _a.fileName);
        doAddAttachment(preTrtAtts);
        setTimeout(() => { var _a; return (_a = document === null || document === void 0 ? void 0 : document.getElementById('attachmentArea')) === null || _a === void 0 ? void 0 : _a.scrollIntoView(); });
    });
    return React.createElement(Component, Object.assign({ uploadAttachmentWithFiles: uploadAttachmentAction }, props, { ref: ref }));
});
export default HOCUploadAttachmentWithFiles;
